import { GENERATOR_ERROR, GENERATOR_WARNING } from 'app/xray/generator/constants';

/**
 * Get the translation key name for a generator error code
 */
export function getErrorKeyName(errorCode: number): string | undefined {
  const entry = Object.entries(GENERATOR_ERROR).find(([, code]) => code === errorCode);
  return entry?.[0];
}

/**
 * Get the translation key name for a generator warning code
 */
export function getWarningKeyName(warningCode: number): string | undefined {
  const entry = Object.entries(GENERATOR_WARNING).find(([, code]) => code === warningCode);
  return entry?.[0];
}

/**
 * Get the full translation key for a generator error code
 */
export function getErrorTranslationKey(errorCode: number): string {
  const keyName = getErrorKeyName(errorCode);
  return keyName ? `xray_generator.status.error.${keyName}` : `xray_generator.status.error.UNKNOWN`;
}

/**
 * Get the full translation key for a generator warning code
 */
export function getWarningTranslationKey(warningCode: number): string {
  const keyName = getWarningKeyName(warningCode);
  return keyName
    ? `xray_generator.status.warning.${keyName}`
    : `xray_generator.status.warning.UNKNOWN`;
}
